import React from 'react'
import { Link } from 'react-router-dom'

export default function Error404({ isLogo = false }) {
    return (
        <section className="h-screen flex items-center justify-center">
            <div className="py-8 px-4 mx-auto">
                <div className="mx-auto max-w-screen-sm text-center">
                    {isLogo && <Link to="/" className="mx-auto w-full max-w-sm mb-3">
                        <img
                            alt="Doctora OPD"
                            src="/assets/images/logo.png"
                            className="mx-auto h-16 w-auto"
                        />
                    </Link>}
                    <h1 className="mb-4 text-7xl tracking-tight font-extrabold lg:text-9xl text-primary-600 dark:text-primary-500">404</h1>
                    <p className="mb-4 text-3xl tracking-tight font-bold text-gray-900 md:text-4xl">Something's missing.</p>
                    <p className="mb-4 text-lg font-light text-gray-500 ">Sorry, we can't find that page. You'll find lots to explore on the home page. </p>
                    <Link to="/" className="btn-blue !inline">Back to Homepage</Link>
                </div>
            </div>
        </section>
    )
}
